import { Body, BodyColor, BodyType, Heading, TypographyColor, TypographyType } from '../../ui-elements';

interface TooltipData {
    presenceData: any;
}
export const PresenceToolTip = ({ presenceData }: TooltipData) => {
    return (
        <div className='d-flex gap-1 flex-column'>
            {presenceData?.properties?.text ?
                <>
                    <Heading
                        title={presenceData?.name}
                        type={TypographyType.h5}
                        colour={TypographyColor.primary}
                        classname='text-start p-0 m-0'
                    />
                    <hr className='m-0 p-0' />
                    {presenceData?.properties?.text.map((phrase: string, index: number) => (
                        <Body
                            key={index}
                            type={BodyType.p3}
                            color={BodyColor.primary}
                            classname="p-0 m-0 d-flex p-0 m-0"
                        >
                            <span className='color-black ff-poppins-bold'>{phrase.split('-')[0]}</span>
                            &nbsp;- {phrase.split('-')[1]}
                        </Body>
                    ))}
                </> :
                <Heading
                    title={`${presenceData?.properties?.count} ${presenceData?.name}`}
                    type={TypographyType.h6}
                    colour={TypographyColor.secondary}
                    classname=''
                />
            }
        </div>
    )
}
